// eslint-disable-next-line no-undef
const object = orecaObject;

const blockDiv = (el) => {
    el.prepend(object.loader);
    el.addClass('loading-div');
};

const unBlockDiv = (el) => {
    el.find('.vn-loader.blocker').remove();
    el.removeClass('loading-div');
};

export { blockDiv, unBlockDiv };
